import React from "react";
import {ReactComponent as CheckedIcon} from '../../assets/checked.svg';
import "./ToggleButton.scss";


type ToggleButtonProps = {
  icon?: React.ReactNode;
  text?: string;
  children?: React.ReactNode;
  selected: boolean;
  disabled?: boolean;
  onChange: (selected: boolean) => void;
  className?: string;
  style?: React.CSSProperties;
  padding?: string;
  alignItems?: "center" | "flex-start" | "flex-end" | undefined;
  width?: string | number;
  selectionIndicator?: boolean;
  withBorder?: boolean;
};

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  icon,
  text,
  children,
  selected,
  disabled = false,
  onChange,
  className = "",
  style = {},
  padding,
  alignItems,
  width = "auto",
  selectionIndicator = true,
  withBorder = true,
}) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={selected}
      onClick={() => onChange(!selected)}
      className={`${withBorder ? 'toggle-button' : 'toggle-button-borderless'} ${className} ${selected ? "selected" : ""}`}
      disabled={disabled}
      style={{
        padding,
        alignItems,
        width,
        ...style,
      }}
    >
    {selectionIndicator ? 
      (<div className="toggle-button-header">
        {icon && <span className="toggle-button-icon">{icon}</span>}
        
        <CheckedIcon className="toggle-button-checked-icon" />
        
      </div>)
      : (<>{icon && <span className="toggle-button-icon">{icon}</span>}</>)}
    
      {text && <span className="toggle-button-text">{text}</span>}
      {children}
    </button>
  );
};